import React, { createContext, useContext, useRef } from 'react';

interface PlayerRefContextType {
  playerRef?: React.RefObject<HTMLElement>;
}

const PlayerRefContext = createContext<PlayerRefContextType | undefined>(undefined);

interface PlayerRefProviderProps {
  playerRef: React.RefObject<HTMLElement>;
  children: React.ReactNode;
}
export function PlayerRefProvider({ playerRef, children }: PlayerRefProviderProps) {
  return <PlayerRefContext.Provider value={{ playerRef }}>{children}</PlayerRefContext.Provider>;
}

export const usePlayerRef = (): PlayerRefContextType => {
  const context = useContext(PlayerRefContext);
  const bodyRef = useRef(document.body);

  if (context === undefined) {
    // This is to support tests that don't have a provider in the tree. In that case it is fine to render in the document.body
    return { playerRef: bodyRef };
  }

  return context || {};
};
